import React from 'react';
import { Box, useTheme } from '@mui/material';

interface CompactAppLogoProps {
    onClick?: () => void;
    /** Short "TMS" on narrow mobile widths */
    compact?: boolean;
}

const CompactAppLogo: React.FC<CompactAppLogoProps> = ({ onClick, compact = false }) => {
    const theme = useTheme();
    const blue = (theme.palette as { blue?: { main?: string } }).blue?.main || theme.palette.primary.main;

    const buttonSx = {
        border: 'none',
        background: 'transparent',
        cursor: onClick ? 'pointer' : 'default',
        p: 0,
        m: 0,
        flexShrink: 0,
        lineHeight: 1,
        fontFamily: "'Lobster', cursive",
        fontWeight: 500,
        color: theme.palette.text.primary,
        whiteSpace: 'nowrap' as const,
    };

    if (compact) {
        return (
            <Box
                component="button"
                type="button"
                onClick={onClick}
                aria-label="The Music School — Admin"
                sx={{ ...buttonSx, fontSize: '1.35rem', letterSpacing: '0.02em' }}
            >
                <Box component="span" sx={{ color: blue }}>T</Box>
                <Box component="span" sx={{ color: blue }}>M</Box>
                <Box component="span" sx={{ color: blue }}>S</Box>
            </Box>
        );
    }

    return (
        <Box
            component="button"
            type="button"
            onClick={onClick}
            aria-label="The Music School — Admin"
            sx={{ ...buttonSx, fontSize: '1rem' }}
        >
            <ColoredLetter blue={blue}>T</ColoredLetter>
            he{' '}
            <ColoredLetter blue={blue}>M</ColoredLetter>
            usic{' '}
            <ColoredLetter blue={blue}>S</ColoredLetter>
            chool
        </Box>
    );
};

const ColoredLetter: React.FC<{ blue: string; children: React.ReactNode }> = ({ blue, children }) => (
    <Box component="span" sx={{ color: blue }}>
        {children}
    </Box>
);

export default CompactAppLogo;
